import { IConsultantSuiviChangementManagerRequestModel } from "./core/_models"
import { Form, Formik, FormikHelpers } from "formik"
import { toast } from "react-toastify"
import { AxiosError } from "axios"
import { IConsultantModel, IEntiteModel, IHttpErrorResponseModel } from "@common-models/*"
import { CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR } from "@common-constants/*"
import MyAlert from "@common-utils/MyAlert"
import MySelectGetAllDataFromServer from "@common-utils/fields/MySelectGetAllDataFromServer"
import { CONST_API_UTILS_GET_ACTIVE_PERSONNELS_ENDPOINT } from "../../../../endpoints"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import React from "react"
import { consultantSuiviChangementManagerRequest } from "./core/_requests"
import MyDateDayMonthYearField from "@common-utils/fields/MyDateDayMonthYearField"
import * as Yup from "yup"
import moment from "moment"

const ConsultantSuiviChangementManager = ({ consultants, onSubmitCallback = () => {}, annulerCallback = () => {} }: IPropsModel) => {
     // Form schema
     const schema = Yup.object().shape({
          date: Yup.string().required().label(`"Date de prise d'effet"`),
          manager: Yup.string().required().label(`"Responsable"`),
     })

     // Init values
     const initialValues: IConsultantSuiviChangementManagerRequestModel = {
          consultants: consultants.map(item => item.id as number),
     }

     // Handle submit
     function handleSubmit(values: IConsultantSuiviChangementManagerRequestModel, helpers: FormikHelpers<IConsultantSuiviChangementManagerRequestModel>) {
          helpers.setStatus(null)

          consultantSuiviChangementManagerRequest(values)
               .then(r => {
                    toast.success("Le changement de manager sera pris en compte à partir du " + moment(values.date).format("dddd D MMMM YYYY"), { autoClose: 5000 })
                    onSubmitCallback(r.data)
               })
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data

                    // Set form errors
                    if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
                         for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
                    }

                    // Set form global status and notify user using a toast
                    helpers.setStatus(error?.detail)
                    toast.error(error?.detail, { autoClose: false })

                    // Stop submit loader
                    helpers.setSubmitting(false)
               })
     }

     return (
          <>
               <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={schema}>
                    {helpers => {
                         return (
                              <Form noValidate autoComplete="off">
                                   {helpers.status && (
                                        <MyAlert type={"danger"} classNames={"mb-4"}>
                                             {helpers.status}
                                        </MyAlert>
                                   )}

                                   {/* Date */}
                                   <div className="row mb-4">
                                        <label className={`col-lg-4 col-form-label fw-bold fs-6 required`}>Date de prise d'effet</label>

                                        <div className="col-lg-8">
                                             <MyDateDayMonthYearField
                                                  name={"date"}
                                                  value={helpers.values.date}
                                                  onChange={val => helpers.setFieldValue("date", val)}
                                                  isInvalid={!!helpers.errors.date}
                                                  placeholder={"Date de prise d'effet"}
                                                  autofocus
                                             />
                                             {helpers.errors.date && <div className={"text-danger"}>{helpers.errors.date}</div>}
                                        </div>
                                   </div>

                                   {/* Manager */}
                                   <div className="row mb-4">
                                        <label className={`col-lg-4 col-form-label fw-bold fs-6 required`}>Nouveau responsable</label>

                                        <div className="col-lg-8">
                                             <MySelectGetAllDataFromServer
                                                  name={"manager"}
                                                  url={CONST_API_UTILS_GET_ACTIVE_PERSONNELS_ENDPOINT}
                                                  value={helpers.values.manager}
                                                  onChange={val => helpers.setFieldValue("manager", val)}
                                                  isInvalid={!!helpers.errors.manager}
                                             />
                                             {helpers.errors.manager && <div className={"text-danger"}>{helpers.errors.manager}</div>}
                                        </div>
                                   </div>

                                   {/* Submit button */}
                                   <div className={"d-flex justify-content-end"}>
                                        <button
                                             className={"btn btn-sm btn-outline btn-outline-primary d-inline-flex align-items-center me-2"}
                                             type={"button"}
                                             onClick={annulerCallback}
                                             disabled={helpers.isSubmitting}
                                        >
                                             Annuler
                                        </button>
                                        <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                             {!helpers.isSubmitting ? <>Appliquer le changement</> : <MySimpleSpinner size={"sm"} />}
                                        </button>
                                   </div>
                              </Form>
                         )
                    }}
               </Formik>
          </>
     )
}

interface IPropsModel {
     consultants: IConsultantModel[]
     annulerCallback?: () => void
     onSubmitCallback?: (val: IEntiteModel) => void
}

export default ConsultantSuiviChangementManager
